// Parenting section (parent users only). Every string carries the PARENTING_
// prefix so it stays globally unique across saga watchers.
export const PARENTING_GET_DASHBOARD = 'PARENTING_GET_DASHBOARD'
export const PARENTING_GET_TODAYS_TIP = 'PARENTING_GET_TODAYS_TIP'
export const PARENTING_GET_TIPS = 'PARENTING_GET_TIPS'
export const PARENTING_GET_TIP = 'PARENTING_GET_TIP'
export const PARENTING_LIKE_TIP = 'PARENTING_LIKE_TIP'
export const PARENTING_GET_WEEKLY_ARTICLE = 'PARENTING_GET_WEEKLY_ARTICLE'
export const PARENTING_GET_ARTICLE = 'PARENTING_GET_ARTICLE'
export const PARENTING_GET_CLASSES = 'PARENTING_GET_CLASSES'
export const PARENTING_ATTEMPT_CLASS = 'PARENTING_ATTEMPT_CLASS'
export const PARENTING_GET_CLASS_QUIZ = 'PARENTING_GET_CLASS_QUIZ'
export const PARENTING_SAVE_QUIZ_ANSWER = 'PARENTING_SAVE_QUIZ_ANSWER'
export const PARENTING_GET_CLASS = 'PARENTING_GET_CLASS'
export const PARENTING_GET_TESTIMONIALS = 'PARENTING_GET_TESTIMONIALS'
export const PARENTING_GET_BLOG_POSTS = 'PARENTING_GET_BLOG_POSTS'
export const PARENTING_GET_BLOG_POST = 'PARENTING_GET_BLOG_POST'
export const PARENTING_POST_BLOG_COMMENT = 'PARENTING_POST_BLOG_COMMENT'
export const PARENTING_GET_NOTIFICATIONS = 'PARENTING_GET_NOTIFICATIONS'
export const PARENTING_GET_CUSTOM_MESSAGE = 'PARENTING_GET_CUSTOM_MESSAGE'
export const PARENTING_GET_EXPERT_OPINION_FORM = 'PARENTING_GET_EXPERT_OPINION_FORM'
export const PARENTING_CREATE_EXPERT_OPINION = 'PARENTING_CREATE_EXPERT_OPINION'
